import React, { useState, useEffect } from 'react'
import './styles.scss'
import Heading from '../heading/Heading'
import Input from './../form/inputs/Input'
import Checkbox from '../form/checkbox/Checkbox';
import Text from '../text/Text';
import Button from '../buttons/Button';
import { useSelector, useDispatch } from 'react-redux'
import ModalMessage from '../modal-message/ModalMessage';
import { generateRandomString } from '../../services/randomString';
import { convertPrice } from '../../services/convertPrice';
import { getApiLink } from '../../services/getApiLink';

const SendEmailCalc = ( props ) => {
    let [ checkOne, setCheckOne ] = useState(false);
    let [ forceValidate, setForceValidate ] = useState(false);
    let [ userEmail, setUserEmail ] = useState('');
    let [ buttonText, setButtonText ] = useState('Send to the email address')
    let [ activeModal, setActiveModal ] = useState(false);
    let [ load, setLoad ] = useState(false);
    let [ disabledButton, setDisabledButton ] = useState(false);

    const dispatch = useDispatch()

    let products            = useSelector(state => state.products)
    let leasingTime         = useSelector(state => state.leasingTime)
    let initialCharge       = useSelector(state => state.initialCharge)
    let productPrice        = useSelector(state => state.productPrice)
    let repurchase          = useSelector(state => state.repurchase)
    let tax                 = useSelector(state => state.tax)
    let selectedLease       = useSelector(state => state.selectedLease)
    let modernLease         = useSelector(state => state.modernLease)
    let traditionalLease    = useSelector(state => state.traditionalLease)
    let finalRate           = useSelector(state => state.finalRate)
    let rateFrequency       = useSelector(state => state.rateFrequency)
    let providerPostal      = useSelector(state => state.providerPostal)
    let callNumber          = useSelector(state => state.callNumber)
    let callEmail           = useSelector(state => state.callEmail)
    let isShop              = useSelector(state => state.isShop)
    let chargePrice         = useSelector(state => state.chargePrice)
    let minMonth            = useSelector(state => state.minMonth)
    let providerName        = useSelector(state => state.providerName)
    let provider            = useSelector(state => state.provider)
    let providerNip         = useSelector(state => state.providerNip)
    // let legalForm           = useSelector(state => state.legalForm)
    let allowForm           = useSelector(state => state.allowForm)
    let identificator       = useSelector(state => state.identificator)
    let rate                = useSelector(state => state.rate)
    let urlFormFinish       = useSelector(state => state.urlFormFinish)
    let courier             = useSelector(state => state.courier)
    let productPriceEnd     = useSelector(state => state.productPriceEnd)
    let successFv           = useSelector(state => state.successFv)
    let disableUpload       = useSelector(state => state.disableUpload)

    useEffect(() => {
        if ( !load ) {
            let random = generateRandomString(16);
            dispatch({ type: 'IDENTIFICATOR_CHANGE', value: random });
            setLoad(true)
        }        
    })

    let validateMail = async() => {
        await dispatch( { type: 'UPLOAD_VALIDATE', value:  true } );
        await setForceValidate(true);
        props.changePage(true);
        await wait(100);
        let scroll = await scrollPage();
        if ( !scroll ) {
            await setForceValidate(false);
            await generateCalculationToDb();
        }
    }
    async function wait(ms) {
        return new Promise(resolve => {
          setTimeout(resolve, ms);
        });
    }

    let scrollPage = () => {
        let result;
        let elements = document.querySelectorAll('div.error-item');
        // let elementsRate = document.querySelectorAll('.leasing-rate-box .error');
        let elementsRate = document.querySelectorAll('.leasing-rate-box .error-item');

        if( elements.length > 0  || elementsRate.length > 0) {
            // window.scroll({
            //     behavior: 'smooth',
            //     left: 0,
            //     top: (elementsRate.length > 0 ? elementsRate[0].offsetTop - 170 : elements[0].offsetTop - 170)
            //   });
            result = true;
        } else {
            result = false;
        }
        return result;
        
    }
    
    let generateCalculationToDb = () => {
        if ( !disabledButton ) {
            setDisabledButton(true);
            setButtonText('I am sending the calculation...')
            let data = {
                // leasingTime: (leasingTime < minMonth ? minMonth : leasingTime),
                leasingTime: leasingTime,
                productPrice: productPrice,
                emailProductPrice: convertPrice(productPrice) + ' AED',
                // productPriceEnd: convertPrice(repurchase) + ' zł',
                productPriceEnd: productPriceEnd,
                tax: tax,
                selectedLease: selectedLease,
                modernLease: modernLease,
                traditionalLease: traditionalLease,
                minMonth: minMonth,
                finalRate: convertPrice(parseFloat(finalRate).toFixed(2)) + ' AED',
                rateFrequency: rateFrequency,
                provider: provider,
                providerName: providerName,
                providerPostal: providerPostal,
                providerNip: providerNip,
                // legalForm: legalForm,
                callNumber: callNumber,
                callEmail: callEmail,
                isShop: isShop,
                chargePrice: chargePrice,
                products: products,
                initialCharge: initialCharge,
                calculationKey: identificator,
                openedMail: 0,
                sendedRepeatMail: 0,
                clientEmail: userEmail,
                allowForm: allowForm,
                rate: JSON.stringify(rate),
                urlFormFinish: urlFormFinish,
                courier: courier,
                modalAxaText: window.AppConfig ? window.AppConfig.modalAxaText : null,
                paramsUrl: disableUpload ? 1 : 0,
            }

            let req = new XMLHttpRequest();
            req.open('POST', `${ getApiLink() }/saveCalculation.php`);
            req.setRequestHeader("Content-Type", "application/json;charset=UTF-8"); 
            req.send(JSON.stringify(data));
            
            req.addEventListener("readystatechange", async function () {
                if (this.readyState === 4) {
                    // let resp = JSON.parse(req.response);
                    setDisabledButton(false)
                    setActiveModal(true);
                    setButtonText('Send to the email address')
                }
            });
            return data
        }
    }

    let formatPrice = (value) => {
        let val = value.toString()
            val = val.replace(/\s/g, '');
            val = val.replace(',', '.');
            val = val.replace('zł', '');
            val = parseFloat(val);

        let input = parseFloat(val).toFixed(2);

        return convertPrice(input);

    }
    
    let checkNaN = (value) => {
        if ( value == 'Na,NaN' || value == 0) {
            return '--'
        } else {
            return value + ' zł';
        }
    }

    let getTextPopup = () => {
        // if(isShop) {
        //     if(allowForm) {
        //         return "Kalkulacja została przesłana na Twój adres e-mail. Zachęcamy do złożenia wniosku online już teraz."
        //     }else{
        //         return "Kalkulacja została przesłana na Twój adres e-mail. Zachęcamy do złożenia wniosku online już teraz.<br>1. Wróć do sklepu.<br>2. Wybierz przedmiot/y i dodaj do koszyka.<br>3. Uzupełnij swoje dane i <strong>złóż zamówienie z formą płatności Leasing GRENKE.</strong><br>Zostaniesz przekierowany do formularza GRENKE, gdzie dopasujesz parametry oferty i złożysz wniosek leasingowy online."
        //     }
        // }else{
        //     if(successFv) {
        //         return "Kalkulacja została przesłana na Twój adres e-mail. Zachęcamy do złożenia wniosku online już teraz."
        //     }else{
        //         return "Kalkulacja została przesłana na Twój adres e-mail."
        //     }
        // }
        return "The non-binding offer has been sent to your email address.";
    }

    return (
        <>
        {/* { (checkNaN(formatPrice(props.rate12)) != '--' || checkNaN(formatPrice(props.rate4)) != '--') && */}
            <div className="send-calc-email">
            {/* <Text text="Administratorem danych osobowych jest <span class='cloud'>GRENKELEASING Sp. z o.o. <span class='hidden'>GRENKELEASING Sp. z o.o., ul. abpa A. Baraniaka 88, 61-131 Poznań, KRS 175740</span></span>(dalej: GRENKE). Więcej informacji na temat uprawnień i przetwarzania Twoich danych osobowych dostępne jest w <a href='https://newonline.leasingoptymalny.pl/od/' target='_blank'>Informacji o danych osobowych.</a>"/> */}
            <Heading title="Send the calculation to your email address"
                tip={ false } 
                tipHeader="Classical lease"
                tipText="Wskaż pełną nazwę firmy wybranego Dostawcy oraz kod pocztowy wskazany na fakturze proforma/zamówieniu." />
                
                <div className="inputs">
                    <div className="input-wrap">
                        <Input 
                            id="user-email-step-1"
                            name={"user-email"}
                            required={ true }
                            setFunction={ val => { setUserEmail(val) } }
                            type="text"
                            label={ "E-mail" }
                            placeholder={ "Insert your email address" }
                            forceValidate={ forceValidate }
                            val={ userEmail } 
                            size="full"
                            reset={props.resetEmailInput} 
                            regExp={/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$/}
                            minChar={ 5 } />
                    </div>

                    <Checkbox   required={ true } 
                                setFunction={ (val) => setCheckOne( val )}
                                forceValidate={ forceValidate }
                                val={ checkOne }
                                id="reg-1-step-1"
                                reset={props.resetEmailInput} 
                                text="I consent to the processing of my personal data contained in this form by grenke for the purpose of receiving an installment calculation proposal." />

                    <Button title={ buttonText }
                            class="black email-send" 
                            arrow={ true } 
                            setFunction={ () => !disabledButton && validateMail() } />

                    {/* <Text class="req-extra-calculation" text="* Required" /> */}

                    <Text class="calculation" text="The data controller is GC Leasing Middle East FZCO Dubai Branch. More information about your rights and the processing of your personal data is available in the Privacy Notice" />
                </div>
            </div>    
            {/* } */}
             { activeModal &&
                <ModalMessage   closeModal={ () => { setActiveModal(false); dispatch( {type: 'UPLOAD_VALIDATE', value:  false } ); } }
                                setFunction={ () =>  props.changePage(false) } 
                                button={ isShop ? false : (successFv ? true : false)} 
                                buttonClass="blue" 
                                buttonTitle={ "Wypełnij wniosek online" }
                                buttonArrow={ true } 
                                tipHeader={ "Thank you!" }
                                tipText={ getTextPopup() } />
            }
        </>
    )
}

export default SendEmailCalc;

